import React, { useEffect, useState } from "react";
import './Login.css';
import { useOktaAuth } from "@okta/okta-react";
import { toast } from "react-toastify";
// import JobsLogo from "../../Assets/JobsOhioLogo.jpeg"
import JobsLogo from "../../Assets/eicilogo.png"
import { authClient } from "../../Utils/Common";
import Checkbox from '@mui/material/Checkbox';
import JobsLogoJoei from "../../Assets/joielogo.png"
const Login = () => {
    const auth = useOktaAuth();
    const loggingIn = (e) => {
        authClient?.token
            .getWithRedirect({
                responseType: ['token', 'id_token'],
                state: 'defaultrandomstring',
            })
            .catch(function (err) {
                console.error('Error OKTA login redirect', err)
            })
    };
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const [showMore, setShowMore] = useState(false);
    const [CheckboxSelected, setCheckboxSelected] = useState(false);
    const loggingOut = async () => auth.oktaAuth.signOut();
    const handleReadMore = () => {
        setShowMore(!showMore);
    };
    const DisableLogin = () => {
        if (CheckboxSelected === false) {
            toast.error("Please tick the checkbox to Login")
            return false
        }
        return true
    }
    useEffect(() => {
        window.localStorage.clear()
        window.sessionStorage.clear()
    }, [])
    return (
        <>
            <section className="login-section-main">
                <div className="section-login-after-main">
                    <div>
                        <img src={JobsLogoJoei} alt="logo" className="logo-login" /></div>
                    <div className="login-card-main">
                        <div className="login-card-content-section">
                            <div className="heading-content-section">
                                <h2>Login with Okta</h2>
                                <div className="Useragreement">
                                    <p className="Login-screen-agree-heading">User Agreement: For Authorized Use Only</p>
                                </div>
                                <div className="login-screen-hide-data">
                                    <p>
                                        The data and information contained in this portal are CONFIDENTIAL and strictly intended for official JobsOhio INTERNAL USE only.
                                        <span className="login-page-reacd-more" onClick={handleReadMore}>
                                        </span>
                                    </p>
                                    <div className="login-screen-hide-data">
                                        <p>
                                            In order to access the JobsOhio Engagement Intelligence ("JOEI”) portal and use the data and information contained in it, you must be an Authorized User. For purposes of this User Agreement, an "Authorized User" is a JobsOhio employee who has received prior written authorization to access the JOEI portal.       </p>
                                        <p>
                                            The information contained in the JOEI portal is not for external distribution or data monetization for profit. Authorized Users should only share information and data from the JOEI portal with other Authorized Users. The data and information contained in the JOEI portal shall not be used, reproduced, distributed, or communicated to any unauthorized persons, external stakeholders, or other third parties.
                                        </p>
                                        <p>
                                            All use of the JOEI portal is monitored for security and administrative purposes. When you access this portal, you are consenting to such monitoring. Use of the JOEI portal in violation of these terms is strictly prohibited and constitutes a violation of the JobsOhio Standards of Conduct and the JobsOhio Employee Handbook.
                                        </p>
                                        <p>Our commitment to best-in-class solutions remains solid, ensuring all event information on calendars is synced on the internal JOEI platform with the latest data and AI technology. </p><p>
                                            In the rare event of a data sync issue caused by timing or other permission issues (approximately 1% of cases), our support team is ready to review your specific case and provide personalized assistance.</p>
                                        <p>
                                            Kindly email <a target="_blank" href="mailto:adminsupport@jobsohio.com">adminsupport@jobsohio.com</a> for functional sync questions <a target="_blank" href="mailto:enterprisedata@jobsohio.com">enterprisedata@jobsohio.com</a> for technical support.</p>
                                        <p>
                                            By checking this box and clicking “login” below, you are agreeing to the terms and conditions set forth above.
                                            <span className="login-page-reacd-more" onClick={handleReadMore}>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="Login-screencheckbox">
                                    <Checkbox {...label} checked={CheckboxSelected} onChange={(e) => setCheckboxSelected(e.target.checked)} size="small" />
                                    <p >I agree to the above and wish to continue</p>
                                </div>
                                <form onSubmit={loggingIn}>
                                    <div className="login-button-section">
                                        {!CheckboxSelected ?
                                            <button type="button" onClick={DisableLogin} className="disablebutton" >Login</button>
                                            :
                                            <button type="button" onClick={loggingIn}>Login</button>
                                        }
                                    </div>
                                    <div className="login-button-section-okta">
                                        {
                                            auth.authState?.isAuthenticated ?
                                                <button type="submit" onClick={loggingOut}
                                                >Logout</button> :
                                                null
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default Login;